import { forwardRef } from 'react';
import { ButtonLinkBase, ButtonLinkBaseProps, ButtonLinkBaseRef } from './ButtonLinkBase';

type ButtonLinkPropsWithoutStyleOptions = Omit<ButtonLinkBaseProps, 'kind' | 'className' | 'style'>;

export const ButtonLinkPrimary = forwardRef<ButtonLinkBaseRef, ButtonLinkPropsWithoutStyleOptions>(
  (props, ref) => <ButtonLinkBase {...props} kind="primary" ref={ref} />,
);
